<div
  *ngIf="ready"
  [ngStyle]="{
    'background-color': selected ? option.selectedColor : option.backgroundColor
  }"
  class="multiselect-option"
  [ngClass]="{ selected: selected, card: isCard }"
  (click)="onClick()"
>
  <app-content-repeater [items]="contents"></app-content-repeater>
</div>
